export const ROUTE_MILESTONE_PLANNER_OVERVIEW = "milestonePlanner.overview";
export const ROUTE_MILESTONE_PLANNER_DETAIL = "milestonePlanner.detail";
export const ROUTE_MILESTONE_PLANNER_FULLGRID = "milestonePlanner.fullGrid";
export const ROUTE_MILESTONE_PLANNER_OVERVIEW_VISITORS =
  "milestonePlanner.overview.visitors";
export const ROUTE_MILESTONE_PLANNER_DETAIL_VISITORS =
  "milestonePlanner.detail.visitors";
export const ROUTE_MILESTONE_PLANNER_FULLGRID_VISITORS =
  "milestonePlanner.fullGrid.visitors";
